/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_Facetedfilter_Noresults2Inputs */

const id_table_facetedfilter_noresults2 = /** @type {(inputs: Table_Facetedfilter_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada hasil ditemukan.`)
};

const ms_table_facetedfilter_noresults2 = /** @type {(inputs: Table_Facetedfilter_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada hasil ditemui.`)
};

const da_table_facetedfilter_noresults2 = /** @type {(inputs: Table_Facetedfilter_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen resultater fundet.`)
};

const de_table_facetedfilter_noresults2 = /** @type {(inputs: Table_Facetedfilter_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Ergebnisse gefunden.`)
};

const en_us2_table_facetedfilter_noresults2 = /** @type {(inputs: Table_Facetedfilter_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No results found.`)
};

const es_es2_table_facetedfilter_noresults2 = /** @type {(inputs: Table_Facetedfilter_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron resultados.`)
};

const es_mx2_table_facetedfilter_noresults2 = /** @type {(inputs: Table_Facetedfilter_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron resultados.`)
};

const fil_table_facetedfilter_noresults2 = /** @type {(inputs: Table_Facetedfilter_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang nakitang resulta.`)
};

const fr_table_facetedfilter_noresults2 = /** @type {(inputs: Table_Facetedfilter_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun résultat trouvé.`)
};

const it_table_facetedfilter_noresults2 = /** @type {(inputs: Table_Facetedfilter_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun risultato trovato.`)
};

const hu_table_facetedfilter_noresults2 = /** @type {(inputs: Table_Facetedfilter_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nincs találat.`)
};

const nl_table_facetedfilter_noresults2 = /** @type {(inputs: Table_Facetedfilter_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen resultaten gevonden.`)
};

const no_table_facetedfilter_noresults2 = /** @type {(inputs: Table_Facetedfilter_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen resultater funnet.`)
};

const pl_table_facetedfilter_noresults2 = /** @type {(inputs: Table_Facetedfilter_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie znaleziono wyników.`)
};

const pt_br2_table_facetedfilter_noresults2 = /** @type {(inputs: Table_Facetedfilter_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No results found.`)
};

const pt_table_facetedfilter_noresults2 = /** @type {(inputs: Table_Facetedfilter_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum resultado encontrado.`)
};

const ro_table_facetedfilter_noresults2 = /** @type {(inputs: Table_Facetedfilter_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu s-au găsit rezultate.`)
};

const fi_table_facetedfilter_noresults2 = /** @type {(inputs: Table_Facetedfilter_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei tuloksia.`)
};

const sv_table_facetedfilter_noresults2 = /** @type {(inputs: Table_Facetedfilter_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga resultat hittades.`)
};

const vi_table_facetedfilter_noresults2 = /** @type {(inputs: Table_Facetedfilter_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy kết quả.`)
};

const tr_table_facetedfilter_noresults2 = /** @type {(inputs: Table_Facetedfilter_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonuç bulunamadı.`)
};

const cs_table_facetedfilter_noresults2 = /** @type {(inputs: Table_Facetedfilter_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nebyly nalezeny žádné výsledky.`)
};

const bg_table_facetedfilter_noresults2 = /** @type {(inputs: Table_Facetedfilter_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма намерени резултати.`)
};

const ru_table_facetedfilter_noresults2 = /** @type {(inputs: Table_Facetedfilter_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Результаты не найдены.`)
};

const uk_table_facetedfilter_noresults2 = /** @type {(inputs: Table_Facetedfilter_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Результатів не знайдено.`)
};

const ar_table_facetedfilter_noresults2 = /** @type {(inputs: Table_Facetedfilter_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم العثور على نتائج.`)
};

const hi_table_facetedfilter_noresults2 = /** @type {(inputs: Table_Facetedfilter_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई परिणाम नहीं मिला।`)
};

const th_table_facetedfilter_noresults2 = /** @type {(inputs: Table_Facetedfilter_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบผลลัพธ์`)
};

const ja_table_facetedfilter_noresults2 = /** @type {(inputs: Table_Facetedfilter_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`結果が見つかりません。`)
};

const zh_cn2_table_facetedfilter_noresults2 = /** @type {(inputs: Table_Facetedfilter_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No results found.`)
};

const zh_hant1_table_facetedfilter_noresults2 = /** @type {(inputs: Table_Facetedfilter_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No results found.`)
};

const ko_table_facetedfilter_noresults2 = /** @type {(inputs: Table_Facetedfilter_Noresults2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No results found.`)
};

/**
* | output |
* | --- |
* | "No results found." |
*
* @param {Table_Facetedfilter_Noresults2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const table_facetedfilter_noresults2 = /** @type {((inputs?: Table_Facetedfilter_Noresults2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Facetedfilter_Noresults2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_table_facetedfilter_noresults2(inputs)
	if (locale === "ms") return ms_table_facetedfilter_noresults2(inputs)
	if (locale === "da") return da_table_facetedfilter_noresults2(inputs)
	if (locale === "de") return de_table_facetedfilter_noresults2(inputs)
	if (locale === "en-US") return en_us2_table_facetedfilter_noresults2(inputs)
	if (locale === "es-ES") return es_es2_table_facetedfilter_noresults2(inputs)
	if (locale === "es-MX") return es_mx2_table_facetedfilter_noresults2(inputs)
	if (locale === "fil") return fil_table_facetedfilter_noresults2(inputs)
	if (locale === "fr") return fr_table_facetedfilter_noresults2(inputs)
	if (locale === "it") return it_table_facetedfilter_noresults2(inputs)
	if (locale === "hu") return hu_table_facetedfilter_noresults2(inputs)
	if (locale === "nl") return nl_table_facetedfilter_noresults2(inputs)
	if (locale === "no") return no_table_facetedfilter_noresults2(inputs)
	if (locale === "pl") return pl_table_facetedfilter_noresults2(inputs)
	if (locale === "pt-BR") return pt_br2_table_facetedfilter_noresults2(inputs)
	if (locale === "pt") return pt_table_facetedfilter_noresults2(inputs)
	if (locale === "ro") return ro_table_facetedfilter_noresults2(inputs)
	if (locale === "fi") return fi_table_facetedfilter_noresults2(inputs)
	if (locale === "sv") return sv_table_facetedfilter_noresults2(inputs)
	if (locale === "vi") return vi_table_facetedfilter_noresults2(inputs)
	if (locale === "tr") return tr_table_facetedfilter_noresults2(inputs)
	if (locale === "cs") return cs_table_facetedfilter_noresults2(inputs)
	if (locale === "bg") return bg_table_facetedfilter_noresults2(inputs)
	if (locale === "ru") return ru_table_facetedfilter_noresults2(inputs)
	if (locale === "uk") return uk_table_facetedfilter_noresults2(inputs)
	if (locale === "ar") return ar_table_facetedfilter_noresults2(inputs)
	if (locale === "hi") return hi_table_facetedfilter_noresults2(inputs)
	if (locale === "th") return th_table_facetedfilter_noresults2(inputs)
	if (locale === "ja") return ja_table_facetedfilter_noresults2(inputs)
	if (locale === "zh-CN") return zh_cn2_table_facetedfilter_noresults2(inputs)
	if (locale === "zh-Hant") return zh_hant1_table_facetedfilter_noresults2(inputs)
	return ko_table_facetedfilter_noresults2(inputs)
});
export { table_facetedfilter_noresults2 as "table.facetedFilter.noResults" }